import { useMutation, useQueryClient } from "@tanstack/react-query";

import { calculateTotal } from "../../core/checkout.core";
import { CheckoutItemData } from "../../types/checkout";

export function useCalculateTotal() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      items,
      userId,
      usedReward,
      orderOverrideDiscount,
      orderDiscountedPrice,
    }: {
      items: CheckoutItemData[];
      userId?: string;
      usedReward?: number;
      orderOverrideDiscount?: number;
      orderDiscountedPrice?: number;
    }) => {
      return await calculateTotal(items, userId, usedReward, orderOverrideDiscount, orderDiscountedPrice);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["posCheckout"] });
    },
  });
}

